import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, KEYWORDS_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'allKeyword',
  url: `${KEYWORDS_URL}/all`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
